import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { StandardCommandHandlerResolver } from '../../../core/service/command/standard-command-handler-resolver.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { tenantCommand } from '../../model/const/command';
import { Contact } from '../../model/contact';
import { Property } from '../../model/property';
import { RentalObject } from '../../model/rental-object';
import { RentalObjectType } from '../../model/rental-object-type';
import { PrintGdprCommandHandler } from '../../service/command/print-gdpr-command-handler.service';
import { SendRegistrationKeyCommandHandler } from '../../service/command/send-registration-key-command-handler.service';
import { TenantCommandHandlerResolver } from '../../service/command/tenant-command-handler-resolver.service';
import { ColumnDefinitionService } from '../../service/data/column-definition.service';
import { ObjectManagerComponentBase } from './../../../core/component/object-manager/object-manager.base';
import { Company } from './../../model/company';
import { CompanyService } from './../../service/data/company.service';
import { OtherRentalObjectService } from './../../service/data/other-rental-object.service';
import { PremisesService } from './../../service/data/premises.service';
import { RentalObjectTypeService } from './../../service/data/rental-object-type.service';

@Component({
    selector: 'app-rental-object-type-manager',
    templateUrl: './../../../core/component/object-manager/object-manager.template.html',
    styleUrls: ['./../../../core/component/object-manager/object-manager.template.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RentalObjectTypeManagerComponent extends ObjectManagerComponentBase<RentalObjectType> {
  constructor(
    columnDefinitionService: ColumnDefinitionService,
    dataService: RentalObjectTypeService,
    dispatcher: CommandDispatcher,
    handlerResolver: StandardCommandHandlerResolver,
    messageService: MessageService,
    navigationService: NavigationService
  ) {
    super(dataService, messageService, navigationService, dispatcher, handlerResolver);
    this.columnDefinition = columnDefinitionService.create('RentalObjectType');
    this.title = 'RENTAL_OBJECT_TYPE_LIST.HEADER';
    this.preferencesKey = 'rent.rental-object-type.list';
  }
}
